var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
import * as React from 'react';
import { SvgIcon } from '@mui/material';
function LabIconsProductColorsIconInner(props) {
  return /*#__PURE__*/React.createElement("svg", __assign({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.6665 20C6.6665 15.0206 10.2178 13.5491 14.9827 4.6478C15.3161 4.02503 15.3981 3.8505 15.3981 3.8505C15.7304 3.19667 16.2713 3.19281 16.6162 3.85607C16.6162 3.85607 16.7132 4.05609 17.0596 4.69175C21.8885 13.5532 25.3332 15.0236 25.3332 20C25.3332 25.1546 21.1545 29.3333 15.9998 29.3333C10.8452 29.3333 6.6665 25.1546 6.6665 20ZM13.2095 12.5627C12.7848 13.1637 10.3243 16.6443 10.0428 17.1769C9.54519 18.1182 9.33317 18.931 9.33317 20C9.33317 23.6819 12.3179 26.6666 15.9998 26.6666C19.6817 26.6666 22.6665 23.6819 22.6665 20C22.6665 18.9161 22.457 18.0957 21.9667 17.1539C21.6891 16.6207 19.2133 13.0921 18.8353 12.5568C17.822 11.122 15.9998 8.2469 15.9998 8.2469C15.9998 8.2469 14.8031 10.3076 13.2095 12.5627ZM15.9998 25.3333C13.0543 25.3333 10.6665 22.9455 10.6665 20C10.6665 19.2636 11.2635 18.6666 11.9998 18.6666C12.7362 18.6666 13.3332 19.2636 13.3332 20C13.3332 21.4727 14.5271 22.6666 15.9998 22.6666C16.7362 22.6666 17.3332 23.2636 17.3332 24C17.3332 24.7364 16.7362 25.3333 15.9998 25.3333Z",
    fill: ""
  }));
}
export var LabIconsProductColorsIcon = function (props) {
  return /*#__PURE__*/React.createElement(SvgIcon, __assign({
    inheritViewBox: true,
    component: LabIconsProductColorsIconInner
  }, props));
};